import formatCurrency from '@/lib/formatCurrency'
import clsx from 'clsx'

interface PriceDisplayProps {
  secondRowDisplaySmallPrice?: number
  secondRowDisplaySmallComparisonPrice?: number
  secondRowDisplaySmallUnit?: string
  firstRowDisplayPrimaryPrice?: number
  firstRowDisplayPrimaryComparisonPrice?: number
  firstRowDisplayPrimaryUnit?: string
  compact?: boolean
  strikeoutOnly?: boolean
}

const PriceDisplay: React.FC<PriceDisplayProps> = ({
  secondRowDisplaySmallPrice,
  secondRowDisplaySmallComparisonPrice,
  secondRowDisplaySmallUnit,
  firstRowDisplayPrimaryPrice,
  firstRowDisplayPrimaryComparisonPrice,
  firstRowDisplayPrimaryUnit,
  compact = false,
  strikeoutOnly = false,
}) => {
  let isSale = false
  let salePercentage = null
  if (!!secondRowDisplaySmallPrice && !!secondRowDisplaySmallComparisonPrice) {
    isSale = secondRowDisplaySmallPrice < secondRowDisplaySmallComparisonPrice
    salePercentage =
      ((secondRowDisplaySmallComparisonPrice - secondRowDisplaySmallPrice) /
        secondRowDisplaySmallComparisonPrice) *
      100
  }
  const formattedSecondRowDisplaySmallPrice = !!secondRowDisplaySmallPrice
    ? formatCurrency(secondRowDisplaySmallPrice)
    : null
  const formattedSecondRowDisplaySmallComparisonPrice = !!secondRowDisplaySmallComparisonPrice
    ? formatCurrency(secondRowDisplaySmallComparisonPrice)
    : null
  const formattedFirstRowDisplayPrimaryPrice = formatCurrency(firstRowDisplayPrimaryPrice)
  const formattedFirstRowDisplayComparisonPrimaryPrice = formatCurrency(
    firstRowDisplayPrimaryComparisonPrice
  )

  return (
    <div>
      <div
        data-test='pdp-per-yard-price'
        className={clsx(
          ['text-wif-orange font-extrabold mb-[6px]'],
          compact ? 'text-sm' : 'text-base'
        )}
      >
        {!!firstRowDisplayPrimaryPrice && (
          <>
            {formattedFirstRowDisplayPrimaryPrice}/{firstRowDisplayPrimaryUnit}
          </>
        )}
      </div>
      {isSale && !!salePercentage && !!firstRowDisplayPrimaryComparisonPrice && (
        <div data-test='pdp-sale-info' className='flex text-[10px] gap-1'>
          <div
            data-test='pdp-sale-percentage'
            className='bg-wif-orange text-white px-1 pt-0.5 rounded-[4px]'
          >
            {Math.round(salePercentage)}%
          </div>
          <div data-test='pdp-compare-at-price' className='text-[#575757] line-through text-[12px]'>
            {formattedFirstRowDisplayComparisonPrimaryPrice} / {firstRowDisplayPrimaryUnit}
          </div>
        </div>
      )}
      {!!formattedSecondRowDisplaySmallPrice && !strikeoutOnly && (
        <div data-test='pdp-per-roll-price' className={'font-medium text-sm mb-[15px]'}>
          {formattedSecondRowDisplaySmallPrice} / {secondRowDisplaySmallUnit}
        </div>
      )}
    </div>
  )
}

export default PriceDisplay
